<template>
    <div class="modal fade fill-in disable-scroll" id="modal" tabindex="-1" role="dialog" aria-hidden="false"
        style="z-index: 9999" data-backdrop="static">
        <div class="modal-dialog modal-confirm modal-lebar modal-md mt-3">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="card shade">
                        <div class="card-header d-flex">
                            <h3>Link Evidence Justifikasi</h3>
                            <div class="shade ml-auto clickable hoverable bg-white"
                                style=" margin-right: -30px; margin-top: -25px; height: 2rem; width: 2rem; display: flex; justify-content: center; align-items: center;"
                                data-dismiss="modal" data-backdrop="false" @click="closeModal">
                                <i class="bi bi-x" style="font-size: 30px"></i>
                            </div>
                        </div>
                        <form action="#" id="post-hoax-evidence" v-on:submit.prevent="submitForm">
                            <div class="card-body mt-1">
                                <div class="form-group">
                                    <input type="text" name="evidence" value="" id="input-evidence" class="form-control" placeholder="Masukan URL Evidence untuk justifikasi Hoaks" v-model="evidence" required/>
                                </div>
                            </div>
                            <div class="form-group card-footer" align="right">
                                <button type="submit" class="btn btn-warning">Simpan</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import $ from "jquery";
import swal from "sweetalert";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
    name: "modal_evidence",
    components: {},
    data() {
        return {
            evidence: this.evidence_url,
            id_project: this.$store.getters.user.id_project,
        };
    },
    props: {
        id_stream: String,
        evidence_url: String,
        index: Number,
    },
    methods: {
        closeModal: function () {
            this.$parent.modal_evidence = false;
        },
        cancelSearch: function () {
            this.$parent.modal_evidence = false;
            $("#modal").modal("hide");
        },
        submitForm: function () {
            let params = {
                _id: this.id_stream,
                evidence_hoax: this.$sanitize(this.evidence),
            };
            let api = process.env.VUE_APP_API_URL + "post-evidence";
            this.$http
            .post(api, params)
            .then((response) => {
                if (response.status == 200) {          
                    this.$parent.modal_evidence = false;
                    $("#modal").modal("hide");
                    $("body").pgNotification({
                        style: "bar",
                        message:
                            '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Evidence berhasil disimpan.',
                        position: "top",
                        timeout: 4000,
                        type: "success",
                    })
                    .show();
                } else {                              
                    this.$parent.modal_evidence = false;
                    $("#modal").modal("hide");         
                    swal(
                        "Error!",
                        "Gagal memvalidasi data. Silahkan coba lagi.",
                        "warning"
                    );
                }
            })
            .catch(() => {             
                this.$parent.modal_evidence = false;
                $("#modal").modal("hide");            
                swal(
                    "Error!",
                    "Terjadi kesalahan saat memvalidasi data. Silahkan coba lagi.",
                    "warning"
                );
            });
        },
    },
    mounted: function () {
        $("#modal").modal("show");
    }
};
</script>
  
<style scoped>
.modal.fade.fill-in>.close>i {
    font-size: 60px;
}

.modal-lebar {
    max-width: 800px;

}
</style>
  